import { MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { AfterViewInit, Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { CommonServiceProxy, CommonSetting, CompanyDto, Manufacturer, ProductDto, ProductServiceProxy } from '@shared/service-proxies/service-proxies';
import { DefaultSettingService } from '@shared/services/default-setting.service';
import { Utils } from '@shared/utils';
import { finalize } from 'rxjs/internal/operators/finalize';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-product-search-dialog',
  templateUrl: './product-search-dialog.component.html',
  styleUrls: ['./product-search-dialog.component.css']
})

export class ProductSearchDialogComponent extends AppComponentBase implements OnInit, AfterViewInit {

  displayedColumns  = ["companyCode", "code", "definition", "manufacturer", "actions"];
  displayedColumns1 = ["companyCode", "code", "definition", "manufacturer", "actions"];
  displayedColumns2 = ["code", "definition", "manufacturer", "actions"];
  companies: CompanyDto[] = [];
  manufacturers: Manufacturer[] = [];
  dataSource: ProductDto[] = [];
  totalRows = 0;
  selectedCompanyId = 0;
  searchCode = "";
  searchDefinition = "";
  searchDefinition2 = "";
  selectedManufacturer = "0";
  companyVisible = true;
  dataSource2:CommonSetting[]=[];

  @Output() selectedItem: EventEmitter<ProductDto> = new EventEmitter();
  @Output() selectedList: EventEmitter<ProductDto[]> = new EventEmitter();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(injector: Injector,
    private _dialogRef: MatDialogRef<ProductSearchDialogComponent>,
    private _productService: ProductServiceProxy,
    private _defaultSettingsService: DefaultSettingService,
    private _service: CommonServiceProxy,
  ) {
    super(injector);
  }

  ngOnInit() {
    this.selectedCompanyId = this._defaultSettingsService.getCompanyId();
    this.getManufacturersList();
    this.paginator.pageSize = this.pageSize;
    this.loadPagedData();
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        tap(() => this.loadPagedData())
      )
      .subscribe();
  }

  onSelectedCompanyIdChanged(){
    this.getManufacturersList();
    this.reListData();
  }

  private getManufacturersList() {
    this._productService.getManufacturerList(this.selectedCompanyId)
      .subscribe((result) => {
        this.manufacturers = result;
      });
  }
  
  private loadPagedData() {
    this.searchCode = this.searchCode.trim();
    this.searchDefinition = this.searchDefinition.trim();
    
    this.spinner.show();
    this._service.getAll()
    .pipe(
      finalize(() => this.spinner.hide())
    )
    .subscribe((result) => {
      this.dataSource2 = result;
      if (this.dataSource2 != null) {
        this.companyVisible = this.dataSource2[0].value == "true" ? true : false;
    
        if (this.companyVisible) {
          this.displayedColumns = this.displayedColumns1;
        }
        else if (!this.companyVisible) {
          this.displayedColumns = this.displayedColumns2;
        }
      }
    });
    this._productService.getProductListPaged(
      this.selectedCompanyId,
      this.searchCode,
      this.searchDefinition,
      this.searchDefinition2,
      this.selectedManufacturer,
      Utils.NeedAllNumber,
      (this.paginator.pageIndex * this.paginator.pageSize),
      this.paginator.pageSize)
      .pipe(
        finalize(() => this.spinner.hide())
      )
      .subscribe(results => {
        this.dataSource = results.items;
        this.totalRows = results.totalCount;
      });
  }

  reListData() {
    this.paginator.pageIndex = 0;
    this.loadPagedData();
  }

  close(result: any): void {
    this._dialogRef.close(result);
  }

  onSelect(entity: ProductDto) {
    this._dialogRef.close();
    this.selectedItem.emit(entity);
  }
}
